module.exports = __webpack_public_path__ + "img/meeters-band.e779e34d.jpg";